import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { getUiLang } from '../utils/lang';
import { getRecentlyViewed } from '../utils/recentlyViewed';

const fallbackImg = 'https://customer-assets.emergentagent.com/job_welcome-app-440/artifacts/1g8bb7ag_Sunify%20logo%20ok..jpg';

const RecentlyViewed = ({ excludeId = null, limit = 8 }) => {
  const { t, i18n } = useTranslation();
  const { currency } = useCart();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const list = getRecentlyViewed().filter((p) => p.id !== excludeId);
    setItems(list.slice(0, limit));
  }, [excludeId, limit]);

  if (items.length < 2) return null;

  const lang = getUiLang(i18n);
  const getName = (p) =>
    p.translations?.[lang]?.name ||
    p.translations?.sk?.name ||
    p.translations?.en?.name ||
    Object.values(p.translations || {})[0]?.name ||
    '';

  const formatPrice = (p) => {
    const price = currency === 'EUR' ? p.price_eur : p.price_usd;
    const symbol = currency === 'EUR' ? '€' : '$';
    return `${Number(price).toFixed(2)} ${symbol}${p.unit === 'mb' ? '/mb' : ''}`;
  };

  return (
    <section className="container mx-auto px-4 py-12" data-testid="recently-viewed-section">
      <div className="flex items-center gap-3 mb-6">
        <Clock className="h-6 w-6 text-orange-500" />
        <h2 className="text-2xl font-bold">{t('product.recently_viewed', 'Naposledy prezerané')}</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {items.map((p) => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            className="group bg-white rounded-lg overflow-hidden border border-gray-200 hover:border-orange-400 hover:shadow-md transition"
            data-testid="recently-viewed-card"
          >
            <div className="aspect-square bg-gray-100 overflow-hidden">
              <img
                src={p.image || fallbackImg}
                alt={getName(p)}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                onError={(e) => { e.currentTarget.src = fallbackImg; }}
              />
            </div>
            <div className="p-3">
              <div className="text-sm font-medium text-gray-800 line-clamp-2 min-h-[2.5rem]">{getName(p)}</div>
              <div className="mt-1 text-orange-600 font-bold text-sm">{formatPrice(p)}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
